<template>
  <router-link
    :to="`/portal/home/article/${encryptFile(itemHighlights.id)}`"
    class="font-subheader col-span-4 space-y-2 px-4 sm:px-0"
  >
    <!-- TAG -->
    <h2 class="text-sm sm:text-base text-primaryPalette font-semibold">Headlines</h2>
    <!-- META -->
    <h3 class="text-xs sm:text-sm text-primarylightdark">
      {{ renderDateTimeFormat(itemHighlights.createdAt) }}
    </h3>

    <!-- TITLE -->
    <h1
      class="text-primarydark font-headline font-black pt-1 text-2xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight"
    >
      {{ itemHighlights.title }}
    </h1>

    <!-- IMAGE -->
    <div class="py-3">
      <img
        :src="`https://iwcdeped.com/gazetteimages/${itemHighlights.filename}`"
        alt="Banner"
        class="w-full h-auto object-cover rounded-lg"
      />
    </div>
  </router-link>
</template>

<script>
import reusableBase from '@/utils/reusables/dateFormat';
import encryptHandler from '@/utils/encrypt';
import { inject, onMounted, ref } from 'vue';
import DOMPurify from 'dompurify';
export default {
  name: 'HighlightArchiveTabs',
  setup() {
    const axios = inject('$axios');
    const itemHighlights = ref([]);
    const expanded = ref({});
    const { renderDateTimeFormat } = reusableBase();
    const { encryptFile } = encryptHandler();

    onMounted(() => {
      fetchHighlights();
    });
    const toggleExpand = (index) => {
      expanded.value[index] = !expanded.value[index];
    };

    const isLongContent = (content) => {
      return content && content.length > 100;
    };

    const fetchHighlights = async () => {
      try {
        const result = await axios.get(`/api/articles`, {
          params: {
            highlight: false
          }
        });
        console.log(result.data.data);
        itemHighlights.value = result.data.data[0];
      } catch (error) {
        console.log('render', error);
      }
    };
    const sanitizeHtml = (html) => {
      if (!html) return '';

      // Remove &nbsp;
      html = html.replace(/&nbsp;/g, ' ');

      // Remove multiple spaces
      html = html.replace(/\s{2,}/g, ' ');

      // Remove empty paragraphs like <p><br></p>
      html = html.replace(/<p>(\s|<br\s*\/?>)*<\/p>/gi, '');

      // Trim leading & trailing spaces
      html = html.trim();

      return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
    };

    return {
      fetchHighlights,
      itemHighlights,
      sanitizeHtml,
      toggleExpand,
      isLongContent,
      expanded,
      encryptFile,
      renderDateTimeFormat
    };
  }
};
</script>
